<table datatable class="table align-middle effects-table">
	<thead>
		<tr>
			<!--<th class="cell-order text-center">{{'Order' | translate}}</th>-->
			<th></th>
			<th>{{'Determinant' | translate}}</th>
			<th>{{'Formula' | translate}}</th>
			<th class="cell-delete text-center">&nbsp;</th>
		</tr>
	</thead>
	<tbody
           cdkDropList
      [cdkDropListData]="formulaCost?.formulaCostItems"
      (cdkDropListDropped)="dropped($event)">
		<tr cdkDrag *ngFor="let item of formulaCost?.formulaCostItems; let i = index">
			<!--<td class="text-center">{{item.sortOrder + 1}}</td>-->
			<td class="text-center"><i class="fa-solid fa-grip-dots handle"></i></td>
			<td>
				<div (click)="openDeterminantModal(i)">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(item.jsonDeterminants)"
                                                [jsonDeterminants]="item.jsonDeterminants"
                                                [determinantMapById]="determinantMapById"
                    ></determinant-query-readonly>
					<div class="workarea__draghere" *ngIf="isDeterminantEmpty(item.jsonDeterminants)">
						<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
					</div>
				</div>
			</td>
			<td>
				<div (click)="openInfixFormula(i)" class="formula-readonly">
					<div *ngIf="item.prettyPrintInfixFormula!=='NaN' && item.prettyPrintInfixFormula !== '( )'">{{ item.prettyPrintInfixFormula }}</div>
					<div class="workarea__draghere" *ngIf="!item.infixFormula">
						<div class="editBtn text-dark">{{ "Click to add formula" | translate }}</div>
					</div>
					<div class="workarea__draghere text-danger" *ngIf="item.prettyPrintInfixFormula==='NaN'">{{'Invalid formula' | translate}}</div>
				</div>
			</td>
			<td class="text-center">
				<i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false"
					(click)="deleteRow(item.id, i)"></i>
			</td>
		</tr>
		<!--
		<tr>
			<td class="text-center">&nbsp;</td>
			<td>
				<div (click)="openNewDeterminantModal()">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(newRow.jsonDeterminants)"
                                                [jsonDeterminants]="newRow.jsonDeterminants"
                                                [determinantMapById]="determinantMapById"
                    ></determinant-query-readonly>
					<div class="workarea__draghere" *ngIf="isDeterminantEmpty(newRow.jsonDeterminants)">{{'Click to add determinant' | translate}}</div>
				</div>
				<span class="error text-danger" *ngIf="!this.newRow.jsonDeterminants && isEmptyConditionInTablePresented()">
					{{'only_1_row_without_condition_allowed' | translate}}
				</span>
			</td>
            <td>
				<div (click)="addNewInfixFormula()">
					<div *ngIf="newRow.prettyPrintInfixFormula!=='NaN'">{{ newRow.prettyPrintInfixFormula }}</div>
					<div class="workarea__draghere" *ngIf="!newRow.infixFormula">{{'Click to add formula' | translate}}</div>
					<div class="workarea__draghere text-danger" *ngIf="newRow.prettyPrintInfixFormula==='NaN'">{{'Invalid formula' | translate}}</div>
				</div>
			</td>
			<td class="text-center">
				<button class="btn btn-outline-primary" type="button"
					(click)="addNewRow()" [hidden]="isAddButtonDisabled()">{{'Add' | translate}}</button>
				<span class="error text-danger" *ngIf="!isAddButtonDisabled()">
					{{ 'Dont forget!' | translate }}
				</span>
			</td>
		</tr>
		-->
	</tbody>
	<tfoot>
        <tr>
            <th colspan="4" class="text-left">
                <div class="d-inline-block btn btn-link btn-sm" (click)="addNewRow()">
                    <i class="fa fa-plus mr-2"></i>
                    <span>{{'Add a formula' | translate}}</span>
                </div>
            </th>
        </tr>
    </tfoot>
</table>

<drawer [title]="'Manage determinants'"
	[showHeader]="showDrawerHeader"
	[isClosed]="!showDeterminantBuilder"
	[noContentPadding]="true"
	(saveEvent)="saveComponentFormula()"
	[embedded]=false
	(closeEvent)="closeDeterminantModal()"
	class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && selectedFormulaRow"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="selectedFormulaRow.jsonDeterminants"
            (builderUpdated)="updateDeterminant($event)"
            [showBuilder]=true
			[embedded]="false"
            (cancel)="closeDeterminantModal()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>

<formula-builder-section
	*ngIf="costView && !costView.value && openFormula"
	class="row layer sub-layer px-3 pt-1 not-iframe"
	[isEmbedded]="false"
	[directSave]="true"
	(onSave)="addFormulaToCost($event)"
	[costView]="costView"
></formula-builder-section>
